import axiosInstance from "./axiosInstance";

const passwordService = {
    // Request a password reset link or OTP
    forgotPassword: async (payload) => {
        try {
            const body = typeof payload === 'string' ? { email: payload } : payload;
            const response = await axiosInstance.post('/users/forgotPassword', body);
            return response.data;
        } catch (error) {
            throw (error.response && error.response.data) ? error.response.data : error;
        }
    },

    // Optionally verify an OTP/token before resetting
    verifyOtp: async (payload) => {
        try {
            const response = await axiosInstance.post('/users/verify-otp', payload);
            return response.data;
        } catch (error) {
            throw (error.response && error.response.data) ? error.response.data : error;
        }
    },

    // Complete the password reset using token/otp and new password
    resetPassword: async (payload) => {
        try {
            const response = await axiosInstance.post('/users/resetPassword', payload);
            return response.data;
        } catch (error) {
            throw (error.response && error.response.data) ? error.response.data : error;
        }
    },
};

export default passwordService;


